import { useTranslation } from "react-i18next";

/**
 * Standard loading overlay with transparent backdrop.
 * Use for full-page or section-level loading states.
 *
 * Props:
 *  - fullPage: boolean (default true) — fixed overlay covering entire viewport
 *  - className: string — additional wrapper classes
 */
export function LoadingOverlay({ fullPage = true, className = "" }) {
  const { t } = useTranslation();
  const userName = localStorage.getItem("userName") || "";
  const message = t("common.loading", { name: userName }) || "Please wait...";

  const positionClass = fullPage
    ? "fixed inset-0 z-50"
    : "absolute inset-0 z-10";

  return (
    <div
      className={`${positionClass} flex flex-col items-center justify-center bg-black/30 backdrop-blur-[2px] ${className}`}
      data-testid="loading-overlay"
    >
      <div className="bg-white/90 rounded-xl shadow-lg px-8 py-6 flex flex-col items-center gap-3">
        <div className="w-10 h-10 border-[3px] border-emerald-200 border-t-emerald-600 rounded-full animate-spin" />
        <span className="text-sm font-medium text-emerald-800 tracking-wide">
          {message}
        </span>
      </div>
    </div>
  );
}
